import { render } from "./NFTBox.vue?vue&type=template&id=56f16a5f"
import script from "./NFTBox.vue?vue&type=script&lang=js"
export * from "./NFTBox.vue?vue&type=script&lang=js"
script.render = render

export default script